module.exports = __webpack_public_path__ + "static/media/ms1Final_img-min.391532ff.png";